import axios from 'axios';

// Determine base URL from runtime config, then build-time env, then default '/api'
function getBaseUrl(){
  try {
    if (typeof window !== 'undefined' && window.__RUNTIME_CONFIG__ && window.__RUNTIME_CONFIG__.API_URL){
      return window.__RUNTIME_CONFIG__.API_URL;
    }
  } catch(e){}
  if (typeof process !== 'undefined' && process.env && process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  return '/api';
}

const api = axios.create({
  baseURL: getBaseUrl(),
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

// Attach token (if any) from localStorage
api.interceptors.request.use(cfg => {
  try {
    const token = localStorage.getItem('token');
    if (token) cfg.headers.Authorization = `Bearer ${token}`;
  } catch(e){}
  return cfg;
}, err => Promise.reject(err));

// Optional: central response error handling (401 => remove token)
api.interceptors.response.use(resp => resp, err => {
  if (err && err.response && err.response.status === 401) {
    try { localStorage.removeItem('token'); } catch(e){}
  }
  return Promise.reject(err);
});

export default api;
